// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1AQjG","list":"PatternAutocomplete_list__1dKIG"};